<script lang="ts">
  import { PUBLIC_STRAPI_MEDIA } from '$env/static/public';
  import { page } from '$app/state'
  import { validateEmail } from '$lib/js/helpers';
  import { subscribeToNewsletter } from '$lib/js/magento/newsletter';
  import { t } from 'svelte-i18n-lingui';
  import type { Footer } from '$lib/js/strapi/types';

  const subfooter: Footer = page.data.footer;
  let email = $state('')
  let is_valid: boolean | null = $state(null)

  async function addToNewsletter() {
    if(validateEmail(email)) {
      await subscribeToNewsletter(email)
      email = ""
      is_valid = true
    } else {
      is_valid = false
    }
  }
</script>


<div class="subfooter">
  <div class="container">
    <div class="subfooter__inner">

      <div class="subfooter__newsletter">
        <div class="subfooter__newsletter__inner">
          <h2 id="subfooter__newsletter__title" class="head-4">{subfooter?.title}</h2>
          <p class="desc lead-2">{@html subfooter.description}</p>

          <div class="subfooter__newsletter__form">
            <input type="email" bind:value={email} aria-labelledby="subfooter__newsletter__title" placeholder={$t`cliente@gmail.com`}>
            <button class="submit u-btn" type="submit" onclick={() => addToNewsletter()}>{$t`Subscribe`}</button>
          </div>

          {#if is_valid === true}
            <p class="notice success">{$t`You have successfully subscribed`}</p>
          {:else if is_valid === false}
            <p class="notice error">{$t`The email entered is not valid`}</p>
          {/if}
        </div>
      </div>

      <div class="subfooter__shipping">
        <h2 class="shipping-title head-4">{subfooter.shipping_text}</h2>
        <div class="shipping-img">
          <img
            src="{PUBLIC_STRAPI_MEDIA}{subfooter.shipping_img.url}"
            height={subfooter.shipping_img.height}
            width={subfooter.shipping_img.width}
            alt="{$t`Free shipping from €${69}`}"
            title="{$t`Free shipping from €${69}`}"
          >
        </div>
      </div>
    </div>
  </div>
</div>


<style lang="scss">
  .subfooter {
    &__inner {
      display: flex;
      flex-direction: column-reverse;
      column-gap: 20px;

      @media (min-width: 769px) {
        flex-direction: row;
      }

      h2 {
        font-weight: 900;

        @media (min-width: 1200px) {
          line-height: 1.25;
        }
      }
    }

    &__newsletter {
      background-color: var(--grey);
      padding: 20px;
      margin-bottom: 20px;

      @media (min-width: 769px) {
        width: calc(50% - 40px);
      }

      @media (min-width: 1025px) {
        padding: 30px;
        width: calc(50% - 60px);
      }

      @media (min-width: 1200px) {
        padding: 50px;
        width: calc(50% - 100px);
      }

      &__form {
        display: flex;
      }

      &__inner {
        max-width: 490px;
      }

      p.desc {
        margin-bottom: 20px;
      }

      input {
        border: 0;
        max-width: 500px;
        width: calc(100% - 30px);
        font-size: 16px;
        padding: 10px 15px;
      }

      button.submit {
        @media (max-width: 768px) {
          padding: 6px 12px;
        }
      }

      p.notice {
        font-size: 14px;
        margin-top: 10px;

        &.success {
          color: green;
        }

        &.error {
          color: var(--red);
        }
      }
    }

    &__shipping {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      background: var(--grey);
      margin-top: 50px;
      margin-bottom: 20px;

      @media (min-width: 769px) {
        margin-top: 0;
        width: 50%;
      }

      .shipping-title {
        margin: 20px;
        max-width: 200px;

        @media (min-width: 1025px) {
          margin: 30px;
        }

        @media (min-width: 1200px) {
          margin: 50px;
          max-width: 230px;
        }
      }

      .shipping-img {
        width: 50%;
        margin-top: -60px;
        max-width: 260px;
        margin-right: 30px;

        @media (min-width: 1200px) {
          margin-right: 70px;
        }

        img {
          display: flex;
          height: 100%;
          width: 100%;
        }
      }
    }
  }
</style>
